// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NauH5zhD2hZvpP {
  position: relative;
  box-sizing: border-box;
  width: 768px;
  overflow: hidden;
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--ds-surface-overlay, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px rgba(9, 30, 66, 0.15), 0px 0px 1px rgba(9, 30, 66, 0.31));
}
.NauH5zhD2hZvpP:focus {
  outline: 0;
}
.NauH5zhD2hZvpP.DVtxDmkCMy5qRd {
  width: 768px;
}
.NauH5zhD2hZvpP.kIQJDf7Zy2oBaX {
  width: 584px;
}
.NauH5zhD2hZvpP.d3UggRlexL2Ogg {
  width: 500px;
}
@media print {
  .NauH5zhD2hZvpP {
    /* stylelint-disable-next-line declaration-no-important */
    width: 100vw !important;
    /* stylelint-disable-next-line declaration-no-important */
    border-radius: 0 !important;
  }
}
.Y9J4BArcarEAX9 {
  border: none;
  background-color: transparent;
  box-shadow: none;
  margin: var(--ds-space-0, 0) var(--ds-space-100, 8px) auto;
  border-radius: var(--ds-border-radius-circle, 50%);
}
.Y9J4BArcarEAX9:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  box-shadow: none;
}
.Y9J4BArcarEAX9:active {
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  box-shadow: none;
}
.Y9J4BArcarEAX9:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .Y9J4BArcarEAX9:focus {
  outline-color: -webkit-focus-ring-color;
}
.Y9J4BArcarEAX9:focus .mac.firefox {
  outline-color: AccentColor;
}
.Y9J4BArcarEAX9 .BXekJYFkPyovJz {
  margin: var(--ds-space-0, 0);
}
@media only screen and (max-width: 750px), only screen and (max-width: 450px) {
  .NauH5zhD2hZvpP {
    width: auto;
    margin: var(--ds-space-0, 0) var(--ds-space-100, 8px);
  }
  .NauH5zhD2hZvpP.DVtxDmkCMy5qRd,
  .NauH5zhD2hZvpP.kIQJDf7Zy2oBaX,
  .NauH5zhD2hZvpP.d3UggRlexL2Ogg {
    width: auto;
  }
  .NauH5zhD2hZvpP .BXekJYFkPyovJz {
    margin: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-150, 12px) var(--ds-space-150, 12px);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `NauH5zhD2hZvpP`,
	"large": `DVtxDmkCMy5qRd`,
	"medium": `kIQJDf7Zy2oBaX`,
	"small": `d3UggRlexL2Ogg`,
	"closeButton": `Y9J4BArcarEAX9`,
	"body": `BXekJYFkPyovJz`
};
export default ___CSS_LOADER_EXPORT___;
